import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "user-profile" }
const _hoisted_3 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexAvatars',
  setup(__props) {

const avatarSize = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarSize.vue"))
const avatarStatus = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarStatus.vue"))
const avatarShapes = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarShapes.vue"))
const avatarRatio = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarRatio.vue"))
const avatarGrouping = defineAsyncComponent(() => import("@/components/theme/uikits/avatar/avatarGrouping.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Avatars"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(avatarSize)),
          _createVNode(_unref(avatarStatus)),
          _createVNode(_unref(avatarShapes)),
          _createVNode(_unref(avatarRatio)),
          _createVNode(_unref(avatarGrouping))
        ])
      ])
    ])
  ], 64))
}
}

})